import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import ColorSchemeService from "services/ColorSchemeService";

function ColorSchemeUrlSync() {
  const {search} = useLocation();
  useEffect(() => {
    ColorSchemeService.setUrlOverride(search);
  }, [search]);
  return null;
}

export default ColorSchemeUrlSync;
